import React from 'react';
import cl from './Policy.module.css';

const Policy = (props) => {
  return (
    <section className={cl.app_policy}>
      <h1>Politique de confidentialité</h1>
       <h2>DÉCLARATION DE CONFIDENTIALITÉ</h2>
       <p>
         Nous prenons votre vie privée au sérieux et cette déclaration de confidentialité explique comment{' '}
         {props.domain}(collectivement, "nous", "notre" ou "notre") collecte, utilise, partage
         et traiter vos informations.
       </p>

       <h2>Collecte et utilisation des données personnelles</h2>
       <p>
         Les données personnelles sont des informations qui peuvent être utilisées directement ou indirectement
         vous identifier. Les données personnelles comprennent également les données anonymes qui sont liées
         à des informations pouvant être utilisées pour vous identifier directement ou indirectement.
         Les données personnelles ne comprennent pas les données qui ont été irréversiblement
         anonymisée ou agrégée afin qu'elle ne puisse plus nous permettre, que ce soit en
         combinaison avec d'autres informations ou autrement, pour vous identifier.
       </p>
       <h2>Promouvoir la sûreté et la sécurité</h2>
       <p>
         Nous respectons les principes de légalité, de légitimité et de transparence,
         utiliser, et traiter le moins de données dans un périmètre de finalité limité, et
         prendre des mesures techniques et administratives pour protéger la sécurité des
         les données. Nous utilisons des données personnelles pour aider à vérifier les comptes et les utilisateurs
         activité, ainsi que pour promouvoir la sûreté et la sécurité, par exemple en
         surveiller les fraudes et enquêter sur les cas suspects ou potentiellement illégaux
         activité ou violation de nos conditions ou politiques. Un tel traitement est
         sur la base de notre intérêt légitime à contribuer à assurer la sécurité de nos
         produits et services.
       </p>
       <h2>
         Voici une description des types de données personnelles que nous pouvons collecter et
         comment nous pouvons l'utiliser:
       </h2>
       <h2>Quelles sont les données personnelles que nous collectons</h2>
       <h2>ⅰ. Données que vous fournissez :</h2>
       <p>
         Nous collectons les données personnelles que vous fournissez lorsque vous utilisez nos produits et
         services ou interagissez autrement avec nous, comme lorsque vous créez un
         compte, contactez-nous, participez à un sondage en ligne, utilisez notre
         aide ou outil de chat en ligne. Si vous effectuez un achat, nous recueillons des informations personnelles
         données en rapport avec l'achat. Ces données incluent votre paiement
         données, telles que votre numéro de carte de crédit ou de débit et d'autres données de carte
         informations, et d'autres informations de compte et d'authentification, ainsi
         que la facturation, l'expédition et les coordonnées.
       </p>
       <h2>ⅱ. Données sur l'utilisation de nos services et produits :</h2>
       <p>
         Lorsque vous visitez nos sites Web, nous pouvons recueillir des données sur le type de
         l'appareil que vous utilisez, l'identifiant unique de votre appareil, l'adresse IP de votre
         appareil, votre système d'exploitation, le type de navigateur Internet que vous
         utilisation, informations d'utilisation, informations de diagnostic et informations de localisation
         depuis ou à propos des ordinateurs, téléphones ou autres appareils sur lesquels vous
         installer ou accéder à nos produits ou services. Lorsqu'elles sont disponibles, nos
         les services peuvent utiliser le GPS, votre adresse IP et d'autres technologies pour
         déterminer l'emplacement approximatif d'un appareil pour nous permettre d'améliorer notre
         produits et services.
       </p>
       <h2>Comment nous utilisons vos données personnelles</h2>
       <p>
         D'une manière générale, nous utilisons les données personnelles pour fournir, améliorer et
         développer nos produits et services, communiquer avec vous, vous offrir
         publicités et services ciblés, et pour nous protéger, ainsi que nos
         clients.
       </p>
       <h2>
         ⅰ. Fournir, améliorer et développer nos produits et services :
       </h2>
       <p>
         Nous utilisons les données personnelles pour nous aider à fournir, améliorer et développer notre
         produits, services et publicité. Cela inclut l'utilisation de données personnelles
         à des fins telles que l'analyse des données, la recherche et les audits. Tel
         le traitement est fondé sur notre intérêt légitime à vous proposer des produits
         et services et pour la continuité des activités. Si vous participez à un concours, ou
         autre promotion, nous pouvons utiliser les données personnelles que vous fournissez pour administrer
         ces programmes. Certaines de ces activités ont des règles supplémentaires, qui
         peut contenir d'autres données sur la façon dont nous utilisons les données personnelles, nous vous encourageons donc
         vous invite à lire attentivement ces règles avant de participer.
       </p>
       <h2>ⅱ. Communiquer avec vous :</h2>
       <p>
         Sous réserve de votre consentement exprès préalable, nous pouvons utiliser des données personnelles pour envoyer
         vos communications marketing concernant nos propres produits et
         services, communiquer avec vous au sujet de votre compte ou de vos transactions, et
         vous informer de nos politiques et conditions. Si vous ne souhaitez plus
         recevoir des communications par e-mail à des fins de marketing, veuillez nous contacter
         pour vous désinscrire. Nous pouvons également utiliser vos données pour traiter et répondre à vos
         demandes lorsque vous nous contactez. Sous réserve de votre consentement exprès préalable, nous
         peut partager vos données personnelles avec des partenaires tiers qui peuvent vous envoyer
         communications marketing relatives à leurs produits et services.
         Sous réserve de votre consentement exprès préalable, nous pouvons utiliser des données personnelles pour
         personnaliser votre expérience avec nos produits et services et sur
         sites Web et applications tiers et pour déterminer l'efficacité
         de nos campagnes promotionnelles.
       </p>
       <p>
         REMARQUE : pour toutes les utilisations de vos données décrites ci-dessus qui nécessitent votre
         consentement exprès préalable, notez que vous pouvez retirer votre consentement en
         nous contacter.
       </p>
       <h2>Définition des "Cookies"</h2>
       <p>
         Les cookies sont de petits morceaux de texte utilisés pour stocker des informations sur le Web
         navigateurs. Les cookies sont largement utilisés pour stocker et recevoir des identifiants et
         d'autres informations sur les ordinateurs, téléphones et autres appareils. Nous utilisons également
         d'autres technologies, y compris les données que nous stockons sur votre navigateur Web ou
         appareil, identifiants associés à votre appareil et autres logiciels, pour
         fins similaires. Dans cette déclaration relative aux cookies, nous nous référons à tous ces
         technologies en tant que "cookies".
       </p>
       <h2>Utilisation des cookies</h2>
       <p>
         Nous utilisons des cookies pour fournir, protéger et améliorer nos produits et
         services, par exemple en personnalisant le contenu, en offrant et en mesurant
         publicités, comprendre le comportement des utilisateurs et fournir un environnement plus sûr
         expérience. Veuillez noter que les cookies spécifiques que nous pouvons utiliser varient
         en fonction des sites Web et des services spécifiques que vous utilisez.
       </p>
       <h2>Divulgation des données personnelles</h2>
       <p>
         Nous mettons certaines données personnelles à la disposition de partenaires stratégiques qui travaillent
         avec nous pour fournir nos produits et services ou nous aider à commercialiser
         clients. Les données personnelles ne seront partagées par nous qu'avec ces sociétés
         afin de fournir ou d'améliorer nos produits, services et publicités ;
         il ne sera pas partagé avec des tiers pour leur propre marketing
         fins sans votre consentement exprès préalable.
       </p>
       <h2>Divulgation ou stockage, transfert et traitement des données</h2>
       <h2>ⅰ. Respect des obligations légales :</h2>
       <p>
         En raison des lois impératives de l'Espace économique européen ou du pays
         dans lequel vit l'utilisateur, certains actes juridiques existent ou ont eu lieu et
         certaines obligations légales doivent être remplies. Traitement des personnels
         données des résidents de l'EEE ---Comme décrit ci-dessous, si vous résidez dans
         Espace économique européen (EEE), notre traitement de vos données personnelles
         être légitimé : Chaque fois que nous avons besoin de votre consentement pour le traitement de
         vos données personnelles, ce traitement sera justifié conformément à l'article
         6(1) du Règlement général sur la protection des données (UE) (« RGPD »).
       </p>
       <h2>
         ⅱ. Aux fins de la mise en œuvre ou de l'application raisonnable de la présente
         article:
       </h2>
       <p>
         Nous pouvons partager des données personnelles avec toutes nos sociétés affiliées. Dans le
         cas de fusion, réorganisation, acquisition, joint-venture,
         cession, scission, transfert, vente ou disposition de tout ou partie
         partie de nos activités, y compris dans le cadre de toute faillite ou
         procédures similaires, nous pouvons transférer toutes les données personnelles au
         tiers concerné. Nous pouvons également divulguer des données personnelles si nous déterminons
         de bonne foi que la divulgation est raisonnablement nécessaire pour protéger notre
         droits et poursuivre les recours disponibles, appliquer nos termes et conditions,
         enquêter sur les fraudes ou protéger nos opérations ou nos utilisateurs.
       </p>
       <h2>ⅲ. Conformité légale et sécurité ou protection d'autres droits</h2>
       <p>
         Cela peut être nécessaire - en vertu de la loi, d'une procédure judiciaire, d'un litige et/ou de demandes
         des autorités publiques et gouvernementales à l'intérieur ou à l'extérieur de votre pays
         de résidence—pour que nous divulguions des données personnelles. Nous pouvons également divulguer
         données personnelles si nous déterminons qu'à des fins de sécurité nationale,
         l'application de la loi, ou d'autres questions d'importance publique, la divulgation est
         nécessaire ou approprié.
       </p>
       <h2>Enfants</h2>
       <p>
         Nos produits et services sont destinés aux adultes. En conséquence, nous faisons
         ne pas collecter, utiliser ou divulguer sciemment des données d'enfants de moins de 16 ans. Si
         nous apprenons que nous avons collecté les données personnelles d'un enfant de moins de 16 ans,
         ou l'âge minimum équivalent selon la juridiction, nous
         prendre des mesures pour supprimer les données dès que possible. S'il vous plaît immédiatement
         contactez-nous si vous apprenez qu'un enfant de moins de 16 ans nous a fourni
         avec des données personnelles.
       </p>
       <h2>Vos droits</h2>
       <p>
         Nous prenons des mesures raisonnables pour nous assurer que vos données personnelles sont exactes,
         complète et à jour. Vous disposez d'un droit d'accès, de rectification ou
         supprimer les données personnelles que nous collectons. Vous avez également droit à
         restreindre ou s'opposer, à tout moment, au traitement ultérieur de vos
         données personnelles. Vous avez le droit de recevoir vos données personnelles dans un
         format structuré et standard. Vous pouvez porter plainte auprès du
         l'autorité compétente en matière de protection des données concernant le traitement de vos
         données personnelles. Pour protéger la confidentialité et la sécurité de vos données personnelles
         données, nous pouvons vous demander des données pour nous permettre de confirmer votre identité
         et le droit d'accéder à ces données, ainsi que de rechercher et de vous fournir
         avec les données personnelles que nous conservons. Il y a des cas, le cas échéant
         les lois ou les exigences réglementaires nous autorisent ou nous obligent à refuser de fournir
         ou supprimer tout ou partie des données personnelles que nous conservons. Vous pouvez
         contactez-nous pour exercer vos droits. Nous répondrons à votre demande dans un
         délai raisonnable, et en tout état de cause inférieur à 30 jours.
       </p>
       <h2>Sites Web et services tiers</h2>
       <p>
         Lorsqu'un client exploite un lien vers un site Web tiers qui a un
         relation avec nous, nous n'assumons aucune obligation ou responsabilité
         pour une telle politique en raison de la politique de confidentialité du tiers. Notre
         les sites Web, les produits et les services peuvent contenir des liens vers ou la possibilité de
         vous permettre d'accéder à des sites Web, produits et services tiers. Nous ne sommes pas
         responsable des pratiques de confidentialité employées par ces tiers,
         nous ne sommes pas non plus responsables des informations ou du contenu de leurs produits et
         contiennent. Cette déclaration de confidentialité s'applique uniquement aux données
         collectées par nous via nos produits et services. Nous vous encourageons à
         lire les politiques de confidentialité de tout tiers avant de procéder à l'utilisation
         leurs sites Web, produits ou services.
       </p>
       <h2>Sécurité, intégrité et conservation des données</h2>
       <p>
         Nous utilisons une sécurité technique, administrative et physique raisonnable
         mesures conçues pour protéger et aider à prévenir l'accès non autorisé à
         vos données, et d'utiliser correctement les données que nous collectons. Nous conserverons votre
         données personnelles aussi longtemps que nécessaire pour atteindre les finalités
         décrites dans la présente déclaration de confidentialité, à moins qu'une période de conservation plus longue ne soit
         requis ou autorisés par la loi.
       </p>
       <h2>Modifications de cette déclaration de confidentialité</h2>
       <p>
         Nous pouvons périodiquement modifier cette déclaration de confidentialité pour suivre le rythme des nouvelles
         technologies, les pratiques de l'industrie et les exigences réglementaires, parmi
         autres raisons. Votre utilisation continue de nos produits et services après la
         date d'entrée en vigueur de la déclaration de confidentialité signifie que vous acceptez les
         Déclaration de confidentialité révisée. Si vous n'êtes pas d'accord avec la version révisée, contactez-nous
         Déclaration de confidentialité, veuillez vous abstenir d'utiliser nos produits ou services
         et contactez-nous pour fermer tout compte que vous pourriez avoir créé.
       </p>
       <h2>Contactez-nous</h2>
       <p>
         Si vous avez des questions concernant cette déclaration de confidentialité ou ses
         mise en œuvre, voici comment vous pouvez nous joindre : soutien@{props.domain}
      </p>
    </section>
  );
};

export default Policy;
